'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypesElementtype = require('prop-types-elementtype');

var _propTypesElementtype2 = _interopRequireDefault(_propTypesElementtype);

var _Basket = require('@deliveroo/icon-set/react/Basket');

var _Basket2 = _interopRequireDefault(_Basket);

var _Person = require('@deliveroo/icon-set/react/Person');

var _Person2 = _interopRequireDefault(_Person);

var _Receipts = require('@deliveroo/icon-set/react/Receipts');

var _Receipts2 = _interopRequireDefault(_Receipts);

var _NavHeader = require('../NavHeader');

var _NavHeader2 = _interopRequireDefault(_NavHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * The main navigation header for Consumer Web. This includes account, order history,
 * basket and promotions specific to the consumer site.
 */
var ConsumerNavHeader = function ConsumerNavHeader(_ref) {
  var accountEmail = _ref.accountEmail,
      basket = _ref.basket,
      links = _ref.links,
      account = _ref.account,
      orderHistory = _ref.orderHistory,
      logoHomeLink = _ref.logoHomeLink,
      props = _objectWithoutProperties(_ref, ['accountEmail', 'basket', 'links', 'account', 'orderHistory', 'logoHomeLink']);

  var isLoggedIn = !!(accountEmail && accountEmail.length);

  var basketLink = basket && basket.value ? [{ label: basket.value, href: basket.href, icon: _Basket2.default }] : [];

  var consumerNavLinks = [_extends({}, account, {
    icon: _Person2.default,
    subtext: accountEmail,
    isProtected: true
  }), _extends({}, orderHistory, {
    icon: _Receipts2.default,
    isProtected: true
  })].concat(basketLink, _toConsumableArray(links));

  return _react2.default.createElement(_NavHeader2.default, _extends({
    links: consumerNavLinks,
    isLoggedIn: isLoggedIn,
    home: { href: logoHomeLink }
  }, props));
};

ConsumerNavHeader.displayName = 'ConsumerNavHeader';
/**
 * Specific-purpose links in the navigation need just a label and a href; any
 * icon is determined by its specific purpose.
 */
var LINK_PROPS = {
  label: _propTypes2.default.string.isRequired,
  href: _propTypes2.default.string.isRequired
};

/**
 * Promotion-specific links follow this pattern as they may (or may not) have a
 * click handler, and have a custom icon where rendered in the navigation bar.
 */
var PROMOTIONAL_LINK_PROPS = {
  label: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  href: _propTypes2.default.string,
  icon: _propTypesElementtype2.default.isRequired
};

ConsumerNavHeader.propTypes = {
  /**
   * Additional links to be displayed, in priority order. These are rendered
   * as part of the main header nav bar and move inside the side nav when there
   * isn’t room for them to be displayed.
   */
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape(PROMOTIONAL_LINK_PROPS)),

  /**
   * The email for the currently logged in account
   */
  accountEmail: _propTypes2.default.string,

  /**
   * The order history link information
   */
  orderHistory: _propTypes2.default.shape(LINK_PROPS).isRequired,

  /**
   * The account page link information
   */
  account: _propTypes2.default.shape(LINK_PROPS).isRequired,

  /**
   * The logout link information
   */
  logout: _propTypes2.default.shape(LINK_PROPS).isRequired,

  /**
   * The login link information
   */
  login: _propTypes2.default.shape(LINK_PROPS).isRequired,

  /**
   * The label for the menu button that always shows on the screen
   */
  menuLabel: _propTypes2.default.string.isRequired,

  /**
   * List of languages which will be displayed in the langauge selector
   */
  languages: _propTypes2.default.arrayOf(_propTypes2.default.shape(LINK_PROPS)),

  /**
   * List of countries which will be displayed in the country selector
   */
  countries: _propTypes2.default.arrayOf(_propTypes2.default.shape(LINK_PROPS)).isRequired,

  /**
   * The current basket state
   */
  basket: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    href: _propTypes2.default.string
  }),

  /**
   * Render prop for promotional content. Any links that have the same label
   * as those in the links prop will only be displayed in the promotional section
   * of the sidebar.
   */
  renderPromotions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    link: _propTypes2.default.shape({ label: _propTypes2.default.string.isRequired }),
    key: _propTypes2.default.string.isRequired,
    promotion: _propTypes2.default.func.isRequired
  })),

  /**
   * Link for the Deliveroo logo, i.e. to take you to the homepage.
   */
  logoHomeLink: _propTypes2.default.string,

  /**
   * Logo variant, so the Chinese logo can be used where appropriate.
   */
  logoVariant: _propTypes2.default.string,

  /**
   * Logo color, so it can be used on different colour backgrounds.
   */
  logoColor: _propTypes2.default.string,

  /**
   * If it should overlay content underneath it. The alternative is a solid white bar.
   */
  isSolidBar: _propTypes2.default.bool,

  /**
   * Allows you to specify the portion of your app that should be hidden (via
   * aria-hidden) to prevent assistive technologies such as screenreaders from
   * reading content outside of the menu when it’s open.
   */
  appElement: _propTypes2.default.string.isRequired,

  /**
   * Allows you to use the header on pages with a larger than standard
   * `maxWidth` passed into `PageContainer`.
   */
  containerMaxWidth: _propTypes2.default.string,

  /**
   * Close button label required for accessibility.
   */
  closeButtonLabel: _propTypes2.default.string.isRequired
};

ConsumerNavHeader.defaultProps = {
  links: [],
  accountEmail: null,
  languages: [],
  renderPromotions: [],
  logoHomeLink: '/',
  logoVariant: null,
  logoColor: 'teal',
  basket: {},
  isSolidBar: true,
  containerMaxWidth: 'default'
};

exports.default = ConsumerNavHeader;